import React, { Component } from 'react';
import './TooltipButton.css';

class TooltipButton extends Component {
  state = {};

  click() {
    if (!this.props.disabled) this.props.handleClick();
  }

  render() {
    return (
      <div onClick={() => this.click()} className="TooltipButton">
        <div className="tooltipButtonLabel">{this.props.text ? this.props.text : 'Edit'}</div>
      </div>
    );
  }
}

export default TooltipButton;
